<div class="canvas-container">
    @if (showClear) {
        <button class="clear-button" (click)="clearCanvas()" [style.color]="strokeColor">{{ clearLabel }}</button>
    }
    <canvas #signatureCanvas class="signature-canvas"></canvas>
</div>
